import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useCanRequestChanges } from "@components/ReportReview/hooks/useCanReviewReport";
import { useOpenFinishReview } from "@components/ReportReview/hooks/useFinishReview";

export const RequestChangesMenuItem: React.FC = () => {
  const openFinishReview = useOpenFinishReview();
  const can = useCanRequestChanges();

  return (
    <DropdownMenuItem
      disabled={!can || !openFinishReview}
      onClick={() => openFinishReview?.(ReportReviewerStatus.ChangesRequested)}
    >
      <ExclamationTriangleIcon />
      Request Changes
    </DropdownMenuItem>
  );
};
